import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={13}
      height={13}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M11.957 8.533a7.38 7.38 0 01-2.318-.37c-.37-.125-.907.096-1.03.218-.335.332-1.284 1.28-1.284 1.28a9.687 9.687 0 01-3.98-3.992s.915-.92 1.24-1.24c.208-.202.379-.683.26-1.064a7.392 7.392 0 01-.371-2.322C4.474.468 4.006 0 3.43 0H1.043C.468 0 0 .468 0 1.043 0 7.636 5.364 13 11.957 13c.575 0 1.043-.468 1.043-1.043v-2.38c0-.576-.468-1.044-1.043-1.044z"
        fill="#2F63DE"
      />
      <Path
        opacity={0.2}
        d="M11.957 8.534a7.38 7.38 0 01-2.318-.37c-.352-.12-.745-.033-1.05.233l-2.854 2.854.008.005 2.742-2.678c.312-.266.714-.354 1.074-.233a7.72 7.72 0 002.373.37c.589 0 1.068.467 1.068 1.042v-.18c0-.575-.468-1.043-1.043-1.043z"
        fill="#fff"
      />
      <Path
        d="M7.325 9.659a9.687 9.687 0 01-3.98-3.992L1.76 7.253a12.027 12.027 0 003.986 3.986l1.58-1.58z"
        fill="url(#paint0_linear_8259_3982)"
      />
      <Path
        opacity={0.1}
        d="M12.008 12.819A12.087 12.087 0 01.514 4.508c.155.513.342.995.562 1.477C2.959 10.118 7.126 13 11.957 13c.493 0 .905-.344 1.013-.804a1.054 1.054 0 01-.962.624z"
        fill="#010101"
      />
      <Path
        d="M11.957 8.533a7.38 7.38 0 01-2.318-.37c-.37-.125-.907.096-1.03.218-.335.332-1.284 1.28-1.284 1.28a9.687 9.687 0 01-3.98-3.992s.915-.92 1.24-1.24c.208-.202.379-.683.26-1.064a7.392 7.392 0 01-.371-2.322C4.474.468 4.006 0 3.43 0H1.043C.468 0 0 .468 0 1.043 0 7.636 5.364 13 11.957 13c.575 0 1.043-.468 1.043-1.043v-2.38c0-.576-.468-1.044-1.043-1.044z"
        fill="url(#paint1_linear_8259_3982)"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_8259_3982"
          x1={2.64492}
          y1={6.78911}
          x2={5.80031}
          y2={9.94449}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#010101" stopOpacity={0.1} />
          <Stop offset={1} stopColor="#010101" stopOpacity={0} />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_8259_3982"
          x1={-1.0205}
          y1={3.00011}
          x2={14.0147}
          y2={10.0114}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#fff" stopOpacity={0.2} />
          <Stop offset={1} stopColor="#fff" stopOpacity={0} />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
